import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Film, Layers, Wand2 } from 'lucide-react';
import MiniAngelScene from './MiniAngelScene';

const services = [
  {
    icon: Film,
    title: 'Motion & Animation',
    description: 'Cinematic 3D animations that command attention. Product reveals, brand films, social content.',
    tag: 'MOTION',
    span: 'col-span-1 md:col-span-2 row-span-1',
  },
  {
    icon: Sparkles,
    title: 'Thumbnail & Image Generation',
    description: 'Eye-catching thumbnails and AI-generated imagery optimised for maximum engagement across all platforms.',
    tag: 'VISUAL',
    span: 'col-span-1 row-span-1',
  },
  {
    icon: Layers,
    title: 'Consultancy',
    description: 'Strategic guidance on 3D content, AI workflows, and visual identity. We help you build a roadmap to stand out.',
    tag: 'STRATEGY',
    span: 'col-span-1 row-span-1',
  },
  {
    icon: Wand2,
    title: 'Creative Direction',
    description: 'End-to-end visual strategy. We concept, produce, and deliver entire 3D campaigns.',
    tag: 'DIRECTION',
    span: 'col-span-1 md:col-span-2 row-span-1',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="section-padding relative" data-testid="services-section">
      <div className="section-divider mb-24" />
      {/* Floating 3D angels */}
      <div className="hidden lg:block absolute top-20 right-10 z-0"><MiniAngelScene type="wing" size={180} /></div>
      <div className="hidden lg:block absolute bottom-20 left-10 z-0"><MiniAngelScene type="halo" size={150} /></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="font-mono text-xs tracking-[0.3em] text-white/30 uppercase mb-4">What We Do</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl">SERVICES</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className={`glass-card p-8 md:p-10 ${service.span}`}
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <Icon size={28} strokeWidth={1.5} className="text-white/60" />
                  <span className="font-mono text-[10px] tracking-[0.2em] text-white/20 border border-white/10 px-3 py-1">
                    {service.tag}
                  </span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl mb-3">{service.title}</h3>
                <p className="text-white/35 text-sm leading-relaxed">{service.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
